
import { Component, Prop, Vue } from "vue-property-decorator";
import User from "@/domain/user/User";

@Component
export default class UserList extends Vue {
  @Prop({ default: [] })
  userList!: User[];

  @Prop({ default: false })
  loading!: boolean;

  headers = [
    {
      text: this.$t("user.id.label"),
      value: "userId",
      groupable: false
    },
    {
      text: this.$t("user.name.label"),
      value: "name",
      groupable: false
    },
    {
      text: this.$t("user.email.label"),
      value: "email",
      groupable: false
    },
    {
      text: this.$t("user.role.label"),
      value: "role",
      groupable: false
    },
    {
      text: "",
      value: "data-table-expand",
      groupable: false,
      width: 0
    }
  ];

  editUser(user: User) {
    this.$emit("edit-user", user);
  }
}
